module.exports = __webpack_public_path__ + "static/media/Designer-floor.68d78e05.jpg";